export default "__VITE_ASSET__DphTL4bX__"